import { render, staticRenderFns } from "./returnPayFeeManageList.vue?vue&type=template&id=fff68914&scoped=true"
import script from "./returnPayFeeManageList.vue?vue&type=script&lang=js"
export * from "./returnPayFeeManageList.vue?vue&type=script&lang=js"
import style0 from "./returnPayFeeManageList.vue?vue&type=style&index=0&id=fff68914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff68914",
  null
  
)

export default component.exports